module.exports = __webpack_public_path__ + "img/xihuan1.99af5879.png";